export default "__VITE_ASSET__DAuLnTTL__"